/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { compose, pure, withHandlers } from 'recompose';
import _ from 'lodash';
import cx from 'classnames';
import { Row, Col, Card, CardText } from 'reactstrap';

import { actions } from '../../actions/design';
import FieldWrapper from '../FieldWrapper';
import classes from './SubStepWrapper.scss';

type PropsType = {
  data: StepSectionData,
  onChange: Function,
  onRevert: Function,
};

const INPUT_WIDTH = 7;
const OFFSET = 0;

export class SubStepWrapper extends React.PureComponent<PropsType, *> {
  static defaultProps = {
    data: {
      badge: '',
      fields: {},
    },
  }
  props: PropsType;

  render() {
    const { data, onChange, onRevert } = this.props;
    const badge = data.badge ? `${data.badge.toString()}: ` : '';

    const renderFields = () => _.map(
      data.fields,
      (fieldData: StepFieldData, key: string) => (
        <FieldWrapper onChangeHandler={onChange} onRevertHandler={onRevert} key={key} id={key} data={fieldData} />
      ),
    );

    const blockTitle = `${badge}${data.name}`;

    return (
      <Row className={classes.wrapper}>
        <h4 className={cx('col col-sm-12', classes.cardHeader)}>{blockTitle}</h4>
        <Col xs={12} lg={{ size: INPUT_WIDTH - (OFFSET * 2), offset: OFFSET }}>
          {renderFields()}
        </Col>
        <Col xs={12} lg={12 - INPUT_WIDTH} className={classes.imageCol}>
          <Card body className={classes.imageCard}>
            <CardText />
          </Card>
        </Col>
      </Row>
    );
  }
}

const enhancer = compose(
  connect(),
  pure,
  withHandlers({
    onChange: props => id => (e: InputEvent) => {
      const isSelection = [
        'Opmode', 'IndPNsel', 'Therm_opt',
        'PWM', 'SpmPackage', 'ManualRSink',
        'PartNumber',
      ].includes(id);
      return props.dispatch(actions.changeValue({
        field: id, value: e.target.value, isSelection,
      }));
    },
    onRevert: props => id => props.dispatch(actions.changeValue({
      field: id, revert: true,
    })),
  }),
);

export default enhancer(SubStepWrapper);



// WEBPACK FOOTER //
// ./src/components/SubStepWrapper/SubStepWrapper.js